function initStoreLocator(config) {
  var I = window.TK_SL_I18N || {};
  var defaultLat = parseFloat(config.defaultLat) || 46.603354;
  var defaultLng = parseFloat(config.defaultLng) || 1.888334;
  var defaultZoom = parseInt(config.defaultZoom) || 6;
  var dataUrl = config.dataUrl;

  if (!dataUrl) { console.error('Store locator: no dataUrl'); return; }

  // Init map
  var map = L.map('store-locator-map', { scrollWheelZoom: false })
    .setView([defaultLat, defaultLng], defaultZoom);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19
  }).addTo(map);

  map.on('click', function () { map.scrollWheelZoom.enable(); });

  var storeIcon = L.divIcon({
    className: 'sl-marker',
    html: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40"><path d="M15 0C6.716 0 0 6.716 0 15c0 11.25 15 25 15 25s15-13.75 15-25C30 6.716 23.284 0 15 0z" fill="#000"/><circle cx="15" cy="14" r="6" fill="#fff"/></svg>',
    iconSize: [30, 40],
    iconAnchor: [15, 40],
    popupAnchor: [0, -40]
  });

  var allStores = [];
  var allMarkers = [];
  var markerGroup = L.featureGroup().addTo(map);
  var listEl = document.getElementById('store-locator-list');
  var countEl = document.getElementById('store-locator-count');
  var searchInput = document.getElementById('store-locator-search');
  var searchBtn = document.getElementById('store-locator-btn');
  var geoBtn = document.getElementById('store-locator-geolocate');
  var filtersEl = document.getElementById('store-locator-filters');
  var activeFilter = 'all';
  var userMarker = null;
  var debounceTimer;

  // Load data then auto-geolocate
  fetch(dataUrl)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      allStores = data;
      renderAll(allStores);
      updateCount(allStores.length);

      // Try auto-geolocation silently
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            var userLat = pos.coords.latitude;
            var userLng = pos.coords.longitude;
            addUserMarker(userLat, userLng);
            sortByDistance(userLat, userLng);
          },
          function () {
            // Geoloc refused or failed: show France overview
            showFranceView();
          },
          { timeout: 5000 }
        );
      } else {
        showFranceView();
      }
    })
    .catch(function (err) { console.error('Store locator: failed to load data', err); });

  function showFranceView() {
    if (allStores.length > 0) {
      map.fitBounds(markerGroup.getBounds().pad(0.05));
    } else {
      map.setView([defaultLat, defaultLng], defaultZoom);
    }
  }

  function renderAll(stores) {
    listEl.innerHTML = '';
    markerGroup.clearLayers();
    allMarkers = [];

    stores.forEach(function (store, idx) {
      if (!store.lat || !store.lng) return;

      // Marker
      var marker = L.marker([store.lat, store.lng], { icon: storeIcon });
      var popup = buildPopup(store);
      marker.bindPopup(popup, { className: 'sl-popup', maxWidth: 280 });
      marker.on('click', function () { setActiveCard(idx); });
      markerGroup.addLayer(marker);
      allMarkers.push(marker);

      // Card
      var card = buildCard(store, idx);
      listEl.appendChild(card);
    });
  }

  function buildPopup(store) {
    var h = '<div class="sl-popup-inner">';
    h += '<h4>' + esc(store.name) + '</h4>';
    if (store.type) h += '<p style="color:#c8a97e;font-weight:600;font-size:11px;text-transform:uppercase;letter-spacing:0.08em;margin:2px 0 6px">' + esc(store.type) + '</p>';
    h += '<p>' + esc(store.address) + '</p>';
    if (store.phone) h += '<p>' + esc(store.phone) + '</p>';
    if (store.distance != null) h += '<p style="font-weight:600;color:#333">' + store.distance.toFixed(1) + ' km</p>';
    h += '</div>';
    return h;
  }

  function buildCard(store, idx) {
    var card = document.createElement('div');
    card.className = 'store-locator__card';
    card.dataset.idx = idx;

    var h = '<h3 class="store-locator__card-name">' + esc(store.name) + '</h3>';
    if (store.type) h += '<span class="store-locator__card-type">' + esc(store.type) + '</span>';
    h += '<p class="store-locator__card-address">' + esc(store.address) + '</p>';
    if (store.phone) {
      h += '<p class="store-locator__card-phone">';
      h += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
      h += '<a href="tel:' + esc(store.phone) + '">' + esc(store.phone) + '</a></p>';
    }
    if (store.distance != null) {
      h += '<p class="store-locator__card-distance">' + store.distance.toFixed(1) + ' km</p>';
    }
    h += '<button type="button" class="store-locator__card-directions" aria-label="' + esc(I.directions || 'Itinéraire') + '">';
    h += '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>';
    h += ' ' + esc(I.directions || 'Itinéraire') + '</button>';

    card.innerHTML = h;

    card.addEventListener('click', function (e) {
      if (e.target.closest('.store-locator__card-directions')) {
        e.stopPropagation();
        window.open('https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng, '_blank');
        return;
      }
      map.setView([store.lat, store.lng], 15);
      if (allMarkers[idx]) allMarkers[idx].openPopup();
      setActiveCard(idx);
    });

    return card;
  }

  // Filter by type
  if (filtersEl) {
    filtersEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.store-locator__filter');
      if (!btn) return;

      filtersEl.querySelectorAll('.store-locator__filter').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activeFilter = btn.dataset.filter;
      applyFilter();
    });
  }

  function applyFilter() {
    var filtered;
    if (activeFilter === 'all') {
      filtered = allStores;
    } else if (activeFilter === 'other') {
      var knownTypes = ['Pharmacie', 'Parapharmacie', 'Institut'];
      filtered = allStores.filter(function (s) { return knownTypes.indexOf(s.type) === -1; });
    } else {
      filtered = allStores.filter(function (s) { return s.type === activeFilter; });
    }

    var query = searchInput.value.trim().toLowerCase();
    if (query.length >= 2) {
      filtered = filtered.filter(function (s) {
        return s.name.toLowerCase().indexOf(query) !== -1 ||
               s.address.toLowerCase().indexOf(query) !== -1 ||
               (s.city && s.city.toLowerCase().indexOf(query) !== -1) ||
               (s.postal && s.postal.indexOf(query) !== -1);
      });
    }

    renderAll(filtered);
    updateCount(filtered.length);
    if (filtered.length > 0) {
      map.fitBounds(markerGroup.getBounds().pad(0.05));
    }
  }

  // Search
  searchBtn.addEventListener('click', function () { performSearch(searchInput.value); });
  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); performSearch(searchInput.value); }
  });
  searchInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    if (searchInput.value.trim().length === 0) { applyFilter(); return; }
    debounceTimer = setTimeout(function () { applyFilter(); }, 300);
  });

  function performSearch(query) {
    query = query.trim();
    if (query.length < 2) return;

    fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(query) + '&countrycodes=fr,ch,li,be,lu,mc&limit=1', {
      headers: { 'Accept-Language': 'fr' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.length > 0) {
          var lat = parseFloat(data[0].lat);
          var lng = parseFloat(data[0].lon);
          sortByDistance(lat, lng);
        } else {
          applyFilter();
        }
      })
      .catch(function () { applyFilter(); });
  }

  // Geolocation
  geoBtn.addEventListener('click', function () {
    if (!navigator.geolocation) {
      alert(I.geo_unavailable || "La géolocalisation n'est pas disponible sur votre navigateur.");
      return;
    }
    geoBtn.classList.add('is-loading');
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        geoBtn.classList.remove('is-loading');
        sortByDistance(pos.coords.latitude, pos.coords.longitude);
        addUserMarker(pos.coords.latitude, pos.coords.longitude);
      },
      function () {
        geoBtn.classList.remove('is-loading');
        alert(I.geo_failed || "Impossible de vous localiser.");
      }
    );
  });

  function addUserMarker(lat, lng) {
    if (userMarker) map.removeLayer(userMarker);
    userMarker = L.circleMarker([lat, lng], {
      radius: 8, fillColor: '#4285f4', color: '#fff',
      weight: 2, opacity: 1, fillOpacity: 0.9
    }).addTo(map).bindPopup(I.your_position || 'Votre position');
  }

  function sortByDistance(lat, lng) {
    var filtered = activeFilter === 'all' ? allStores.slice() :
      activeFilter === 'other' ?
        allStores.filter(function (s) { return ['Pharmacie','Parapharmacie','Institut'].indexOf(s.type) === -1; }) :
        allStores.filter(function (s) { return s.type === activeFilter; });

    filtered.forEach(function (s) { s.distance = haversine(lat, lng, s.lat, s.lng); });
    filtered.sort(function (a, b) { return a.distance - b.distance; });

    // Show nearest 100 on map, all in list
    renderAll(filtered.slice(0, 100));

    // But show all in list
    listEl.innerHTML = '';
    filtered.forEach(function (store, idx) {
      var card = buildCard(store, idx);
      listEl.appendChild(card);
    });

    updateCount(filtered.length);
    map.setView([lat, lng], 11);
  }

  function setActiveCard(idx) {
    listEl.querySelectorAll('.store-locator__card').forEach(function (c) { c.classList.remove('is-active'); });
    var card = listEl.querySelector('[data-idx="' + idx + '"]');
    if (card) {
      card.classList.add('is-active');
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function updateCount(n) {
    if (countEl) countEl.textContent = n + ' ' + ((n === 1 || (n === 0 && I.zero_singular !== false)) ? (I.count_one || 'point de vente') : (I.count_other || 'points de vente'));
  }

  function haversine(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  setTimeout(function () { map.invalidateSize(); }, 200);
}
